export default "__VITE_ASSET__Bya6i_0K__"